export interface ErrorScreenProps {
  error: Error;
  onRetry?: () => void;
  onReload?: () => void;
}

/**
 * Error screen fallback UI
 */
export function ErrorScreen({ error, onRetry, onReload }: ErrorScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
          <svg
            className="w-6 h-6 text-red-600"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <h2 className="text-xl font-semibold text-center text-gray-900 mb-2">
          Something went wrong
        </h2>

        <p className="text-center text-gray-600 mb-6">
          We&apos;ve been notified and are working on a fix. Please try again.
        </p>

        {process.env.NODE_ENV === 'development' && (
          <div className="mb-4 p-3 bg-gray-100 rounded text-xs font-mono overflow-auto">
            <strong>Error:</strong> {error.message}
          </div>
        )}

        <div className="flex gap-3">
          {onRetry && (
            <button
              onClick={onRetry}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Try Again
            </button>
          )}

          {onReload && (
            <button
              onClick={onReload}
              className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Reload Page
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
